import { Route, Routes } from "react-router-dom"
import TransferSelect from "../../pages/TransferSelect"
import M2MPullFlow from "../M2MPullFlow"
import { ROUTES_PATHS } from "../../utils/constants"

const TransferFlow = () => (
  <Routes>
    <Route element={<TransferSelect />} index />
    <Route path={`/${ROUTES_PATHS.me}/*`} element={<M2MPullFlow />} />
    <Route path={`/${ROUTES_PATHS.byCardNumber}/*`} element={<div />} />
  </Routes>
)

export default TransferFlow
